import { FunctionComponent, MouseEvent, ReactNode } from 'react';
import { twMerge } from 'src/utils/twMerge';

type Props = {
  icon: ReactNode;
  'aria-label': string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  'data-testid'?: string;
  'aria-disabled'?: boolean;
  isDisabled?: boolean;
  className?: string;
};

const CornerIconButton: FunctionComponent<Props> = ({
  icon,
  'aria-label': ariaLabel,
  onClick,
  'data-testid': testId,
  'aria-disabled': ariaDisabled,
  isDisabled = false,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={isDisabled}
    aria-label={ariaLabel}
    aria-disabled={ariaDisabled}
    data-testid={testId}
    className={twMerge(
      '-m-2.5 flex h-11 w-11 shrink-0 cursor-pointer items-center disabled:cursor-default justify-center bg-transparent p-0',
      className,
    )}
  >
    {icon}
  </button>
);

export default CornerIconButton;
